export default "__VITE_ASSET__CCgTCpcs__"